import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { PDFViewer } from "@react-pdf/renderer";

import { getCourseRegister } from "../../../services";
import { CertificatePDF } from "../../../components/CertificatePDF";

import "./styles.css";

export const Certificado = ({
  handleShowCertificate,
}) => {
  const {
    user,
    course,
    courseAdvance,
  } = useSelector((state) => state);

  const [register, setRegister] = useState(null);

  /* =========================================================
     OBTENER REGISTRO
     ========================================================= */

  useEffect(() => {
    if (!course) return;

    let isMounted = true;

    getCourseRegister(course?.course?.id)
      .then((register) => {
        if (isMounted) {
          setRegister(register);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [user, course]);

  /* =========================================================
     BLOQUEAR SCROLL DEL FONDO
     ========================================================= */

  useEffect(() => {
    const previousOverflow =
      document.body.style.overflow;

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow =
        previousOverflow;
    };
  }, []);

  /* =========================================================
     MODAL
     ========================================================= */

  const viewer = (
    <div
      className="certificate-pdf-overlay"
      onClick={handleShowCertificate}
    >
      <div
        className="certificate-pdf-modal"
        onClick={(event) =>
          event.stopPropagation()
        }
      >

        <div className="certificate-pdf-header">

          <div className="certificate-pdf-title">
            <i className="fas fa-file-pdf" />

            <div>
              <strong>
                Documento de capacitación
              </strong>

              <span>
                DC-3 / Constancia
              </span>
            </div>
          </div>

          <button
            type="button"
            className="certificate-pdf-close"
            onClick={handleShowCertificate}
          >
            <i className="fas fa-times" />
            Cerrar
          </button>

        </div>

        <div className="certificate-pdf-body">

          {register ? (
            <PDFViewer
              className="certificate-pdf-viewer"
            >
              <CertificatePDF
                user={user}
                course={course}
                courseAdvance={courseAdvance}
                register={register}
              />
            </PDFViewer>
          ) : (
            <div className="certificate-pdf-loading">
              <div className="spinner-border" />
              <span>
                Generando documento...
              </span>
            </div>
          )}

        </div>

      </div>
    </div>
  );

  return createPortal(
    viewer,
    document.body
  );
};